import styled from 'styled-components';

export const Container = styled.section`
  .create-free-profile,
  &.create-free-profile {
    padding-top: 60px;
    padding-bottom: 60px;

    &__button {
      color: ${p => p.theme.palette.primary.main};
      display: block;
      margin: 25px auto 0;
      max-width: 294px;
    }
  }
`;

export default Container;
